export default "__VITE_ASSET__Ds4NX4Lj__"